import * as types from './actionTypes';
import artistService from '../services/artistService';
import { fetch, addTask } from 'domain-task';

export function getFeaturedArtists() {
    return (dispatch, getState) => {
        if(getState().artists.featuredArtists.length == 0) {
            let fetchTask = artistService.getFeaturedArtists()
                .then(artists => {
                    if(artists) {
                        dispatch({ type: types.GET_FEATURED_ARTISTS, artists });
                    }
                    return artists;
                });
            addTask(fetchTask);
        }
    };
}

export function getProfile(username, currentProfileID, getTabFunction, tabName) {
    return (dispatch, getState) => {
        let existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if(existingProfile == null || existingProfile.requestedBy !== currentProfileID) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_STATUS, username, 'LOADING');
            let fetchTask = artistService.getProfile(username, currentProfileID)
                .then(profile => {
                    if(profile) {
                        let execGetTabFunction = false;
                        if(existingProfile && existingProfile.RoleID === profile.RoleID) {
                            //we already had the profile, we just reloaded it for the current user, don't 
                            //overwrite the whole object as it'll lose any music/videos/gigs we've loaded,
                            //just set the user-specific fields on the existing profile object
                            //get the existing profile again though as while making the server call to get this profile, we may have loaded other data
                            existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
                            profile = { ...existingProfile, requestedBy: currentProfileID, CommentsEnabled: profile.CommentsEnabled, MessagesEnabled: profile.MessagesEnabled };
                            //the comments tab could change based on who loads it - we only show approved comments if it's not our profile so reload the data for the current user
                            execGetTabFunction = tabName === 'ChatToMe';
                        }
                        else {
                            profile.requestedBy = currentProfileID;
                            execGetTabFunction = true;                            
                        }                        
                        dispatch({ type: types.GET_PROFILE, profile });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_STATUS, username, 'LOADED');
                        if(execGetTabFunction && getTabFunction) {
                            return getTabFunction(profile.Username)
                                .then(response => profile);
                        }
                    }
                    return profile;
                })
                .catch(error => {
                    if(error.message == 'Not found') {
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_STATUS, username, 'NOT_FOUND');
                    }
                    else {
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_STATUS, username, 'FAILED');
                    }
                });
            addTask(fetchTask);
        }
    };
}

function dispatchStatusUpdate(dispatch, type, username, status) {
    let loadingStatus = {username, status: status};
    dispatch({ type, loadingStatus });
}

function dispatchBrowseStatusUpdate(dispatch, type, page, status) {
    let loadingStatus = { page, status };
    dispatch({ type, loadingStatus });
}

export function getBio(username) {
    return (dispatch, getState) => {
        const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if(existingProfile && existingProfile.GetToKnowMe == null) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_BIO_STATUS, username, 'LOADING');
            let fetchTask = artistService.getBio(username)
                .then(bio => {
                    if(bio) {
                        const profileBio = { username, bio };
                        dispatch({ type: types.GET_PROFILE_BIO, profileBio });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_BIO_STATUS, username, 'LOADED');
                        return profileBio;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_BIO_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getMusic(username) {
    return (dispatch, getState) => {
        const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if(existingProfile && existingProfile.Music == null) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_MUSIC_STATUS, username, 'LOADING');
            let fetchTask = artistService.getMusic(username)
                .then(music => {
                    if(music) {
                        const profileMusic = { username, music };
                        dispatch({ type: types.GET_PROFILE_MUSIC, profileMusic });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_MUSIC_STATUS, username, 'LOADED');
                        return profileMusic;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_MUSIC_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getVideos(username) {
    return (dispatch, getState) => {
        const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if(existingProfile && existingProfile.Videos == null) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_VIDEOS_STATUS, username, 'LOADING');
            let fetchTask = artistService.getVideos(username)
                .then(videos => {
                    if(videos) {
                        const profileVideos = { username, videos };
                        dispatch({ type: types.GET_PROFILE_VIDEOS, profileVideos });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_VIDEOS_STATUS, username, 'LOADED');
                        return profileVideos;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_VIDEOS_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getGigs(username) {
    return (dispatch, getState) => {
        const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if(existingProfile && existingProfile.Gigs == null) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_GIGS_STATUS, username, 'LOADING');
            let fetchTask = artistService.getGigs(username)
                .then(gigs => {
                    if(gigs) {
                        const profileGigs = { username, gigs };
                        dispatch({ type: types.GET_PROFILE_GIGS, profileGigs });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_GIGS_STATUS, username, 'LOADED');
                        return profileGigs;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_GIGS_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getBuyOptions(username) {
    return (dispatch, getState) => {
        const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if(existingProfile && existingProfile.BuyOptions == null) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_BUYOPTIONS_STATUS, username, 'LOADING');
            let fetchTask = artistService.getBuyOptions(username)
                .then(buyOptions => {
                    if(buyOptions) {
                        const profileBuyOptions = { username, buyOptions };
                        dispatch({ type: types.GET_PROFILE_BUYOPTIONS, profileBuyOptions });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_BUYOPTIONS_STATUS, username, 'LOADED');
                        return profileBuyOptions;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_BUYOPTIONS_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getAddress(username) {
    return (dispatch, getState) => {
        const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if(existingProfile && existingProfile.Address == null) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_ADDRESS_STATUS, username, 'LOADING');
            let fetchTask = artistService.getAddress(username)
                .then(address => {
                    if(address) {
                        const profileAddress = { username, address };
                        dispatch({ type: types.GET_PROFILE_ADDRESS, profileAddress });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_ADDRESS_STATUS, username, 'LOADED');
                        return profileAddress;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_ADDRESS_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getComments(username, forceReload) {
    return (dispatch, getState) => {
        const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        if((existingProfile && existingProfile.Comments == null) || forceReload) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_COMMENTS_STATUS, username, 'LOADING');
            let fetchTask = artistService.getComments(username)
                .then(comments => {
                    if(comments) {
                        const profileComments = { username, comments };
                        dispatch({ type: types.GET_PROFILE_COMMENTS, profileComments });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_COMMENTS_STATUS, username, 'LOADED');
                        return profileComments;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_COMMENTS_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}

export function getConversation(username, counterUsername) {
    return (dispatch, getState) => {
        //always load the conversation for now as we don't currently have the counterUsername in the store
        //const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        //if(existingProfile && existingProfile.Conversation == null) {
            dispatchStatusUpdate(dispatch, types.GET_PROFILE_CONVERSATION_STATUS, username, 'LOADING');            
            //const modalType = { type: 'PROFILE_CONVERSATION', username }
            //dispatch({ type: types.SHOW_MODAL, modalType });
            let fetchTask = artistService.getConversation(username, counterUsername)
                .then(conversation => {
                    if(conversation) {
                        const profileConversation = { username, counterUsername, conversation };
                        dispatch({ type: types.GET_PROFILE_CONVERSATION, profileConversation });
                        dispatchStatusUpdate(dispatch, types.GET_PROFILE_CONVERSATION_STATUS, username, 'LOADED');
                        return profileConversation;
                    }
                })
                .catch(error => {
                    const profileConversation = { username, counterUsername, conversation: { Conversation: [] } };
                    dispatch({ type: types.GET_PROFILE_CONVERSATION, profileConversation })
                    dispatchStatusUpdate(dispatch, types.GET_PROFILE_CONVERSATION_STATUS, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        //}
    };
}

export function getConnections(username, inbound) {
    return (dispatch, getState) => {
        //always load the conversation for now as we don't currently have the inbound/outbound in the store
        //const existingProfile = getState().artists.profiles.find(profile => profile.Username == username);
        //if(existingProfile && existingProfile.Conversation == null) {
            const actionType = inbound ? types.GET_PROFILE_CONNECTIONS_INBOUND : types.GET_PROFILE_CONNECTIONS_OUTBOUND;
            const actionTypeStatus = inbound ? types.GET_PROFILE_CONNECTIONS_INBOUND_STATUS : types.GET_PROFILE_CONNECTIONS_OUTBOUND_STATUS;
            dispatchStatusUpdate(dispatch, actionTypeStatus, username, 'LOADING');
            //const modalType = { type: inbound ? 'PROFILE_CONNECTIONS_INBOUND' : 'PROFILE_CONNECTIONS_OUTBOUND', username }
            //dispatch({ type: types.SHOW_MODAL, modalType });
            let fetchTask = artistService.getConnections(username, inbound)
                .then(connections => {
                    if(connections) {
                        const profileConnections = { username, connections };
                        dispatch({ type: actionType, profileConnections });
                        dispatchStatusUpdate(dispatch, actionTypeStatus, username, 'LOADED');
                        return profileConnections;
                    }
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, actionTypeStatus, username, 'FAILED');
                    throw(error);
                });
            addTask(fetchTask);
        //}
    };
}

export function setBrowseRoleType(roleType) {
    return { type: types.SET_PROFILE_BROWSE_ROLETYPE, roleType };
}

export function setBrowseTab(selectedTab) {
    return { type: types.SET_PROFILE_BROWSE_TAB, selectedTab };
}

export function setKeyword(keyword) {
    return { type: types.SET_PROFILE_KEYWORD, keyword };
}

export function clearSearchString(keyword) {
    return { type: types.CLEAR_PROFILE_KEYWORD };
}

export function setSearchError(error) {
    return { type: types.SET_PROFILE_SEARCH_ERROR, error: new Error(error) };
}

export function clearSearchError(error) {
    return { type: types.CLEAR_PROFILE_SEARCH_ERROR };
}

export function updateSort(sortField) {
    return { type: types.SET_PROFILE_BROWSE_SORT, sortField };
}

export function updateCapacity(capacity) {
    return { type: types.SET_PROFILE_BROWSE_CAPACITY, capacity };
}

export function updateDistance(distance) {
    return { type: types.SET_PROFILE_BROWSE_DISTANCE, distance };
}

export function updateDistanceUnit(unit) {
    return { type: types.SET_PROFILE_BROWSE_DISTANCE_UNIT, unit };
}

export function updateLocation(location) {
    return { type: types.SET_PROFILE_BROWSE_LOCATION, location };
}

export function updateInstrument(instrument) {
    return { type: types.SET_PROFILE_BROWSE_INSTRUMENT, instrument };
}

export function updateExpertise(expertise) {
    return { type: types.SET_PROFILE_BROWSE_EXPERTISE, expertise };
}

export function addBrowseGenre(genre) {
    return { type: types.SET_PROFILE_BROWSE_ADD_GENRE, genre };
}

export function removeBrowseGenre(genre) {
    return { type: types.SET_PROFILE_BROWSE_REMOVE_GENRE, genre };
}

export function clearBrowseGenres() {
    return { type: types.SET_PROFILE_BROWSE_CLEAR_GENRES };
}

export function setBrowseAssociations(associations) {
    return { type: types.SET_PROFILE_BROWSE_ASSOCIATIONS, associations };
}

export function browseProfiles(page = 1) {
    return (dispatch, getState) => {
        const state = getState();
        const requestingNextPage = page > state.artists.browse.results.lastPage;
        const searchCriteria = state.artists.browse.searchCriteria;
        const selectedTab = state.artists.browse.selectedTab;
        const currentResults = state.artists.browse.results;
        const searchChanged = selectedTab != currentResults.selectedTab || state.artists.browse.keyword != currentResults.keyword || state.artists.browse.roleType.type != currentResults.roleType.type || JSON.stringify(searchCriteria) != JSON.stringify(currentResults.searchCriteria);
        if(searchChanged || requestingNextPage) {
            if(!requestingNextPage) {
                dispatch(clearProfiles());
            }
            dispatchBrowseStatusUpdate(dispatch, types.BROWSE_PROFILES_STATUS, page, 'LOADING');
            let keyword;
            const roleType = state.artists.browse.roleType;
            const roleTypeRoute = roleType.route;
            let sort;
            let distance;
            let distanceUnit;
            let latitude = null;
            let longitude = null;
            let instrument = null;
            let expertise = null;
            let capacityMin = null;
            let capacityMax = null;
            let associationsIDs;
            let genres;
            if (selectedTab == 'browse') {
                associationsIDs = searchCriteria.selectedAssociations.map(a => a.value);
                genres = searchCriteria.selectedGenres;
                sort = searchCriteria.sort;
                distance = searchCriteria.distance;
                distanceUnit = searchCriteria.distanceUnit;
                if(searchCriteria.location.length) {
                    latitude = searchCriteria.location[0].latitude;
                    longitude = searchCriteria.location[0].longitude;
                }
                if(roleType.type == 'Musician') {
                    instrument = searchCriteria.instrument;
                    expertise = searchCriteria.expertise;
                }
                if(roleType.type == 'Venue' && searchCriteria.selectedCapacity) {
                    capacityMin = searchCriteria.selectedCapacity.min;
                    capacityMax = searchCriteria.selectedCapacity.max;
                }
            }
            else {
                keyword = state.artists.browse.keyword;
            }            
            let fetchTask = artistService.browseProfiles(roleTypeRoute, keyword, genres, associationsIDs, distance, distanceUnit, latitude, longitude, instrument, expertise, capacityMin, capacityMax, sort, page)
                .then(data => {
                    if(data) {
                        const results = {
                            lastPage: data.CurrentPage,
                            haveNextPage: data.CurrentPage < data.TotalPages,
                            items: data.Items,
                            selectedTab: selectedTab,
                            searchCriteria: state.artists.browse.searchCriteria,
                            keyword: state.artists.browse.keyword,
                            roleType
                        };
                        dispatch({ type: types.SET_PROFILE_BROWSE_RESULTS, results });
                        dispatchBrowseStatusUpdate(dispatch, types.BROWSE_PROFILES_STATUS, page, 'LOADED');
                    }
                    return data;
                })
                .catch(error => {
                    dispatchBrowseStatusUpdate(dispatch, types.BROWSE_PROFILES_STATUS, page, 'FAILED');
                    dispatch({ type: types.SET_PROFILE_BROWSE_ERROR, error});
                    return Promise.reject(error);
                });
            addTask(fetchTask);
            return fetchTask;
        }
        else {
            return new Promise((resolve, reject) => resolve());
        }
    };
}

export function clearProfiles() {
    return { type: types.CLEAR_PROFILE_BROWSE_RESULTS };
}

export function clearSearchCriteria() {
    return { type: types.CLEAR_PROFILE_SEARCH_CRITERIA };
}

export function clearBrowseError() {
    return { type: types.CLEAR_PROFILE_BROWSE_ERROR };
}

export function wrapServiceCall(func) {
    //we just want to make a service call without dispatching anything - so we can go through middleware and check the token
    return function(dispatch) {
        return func()
            .then(data => data);    
    }
}

export function addComment(username, fromRoleID, text) {
    return wrapServiceCall(() => artistService.addComment(username, fromRoleID, text));
}

export function approveComment(username, commentID) {
    return wrapServiceCall(() => artistService.approveComment(username, commentID));
}

export function deleteComment(username, commentID) {
    return wrapServiceCall(() => artistService.deleteComment(username, commentID));
}

export function addConnection(username, connectToProfileID) {
    return (dispatch, getState) => {
        return artistService.addConnection(username, connectToProfileID)
            .then(data => {
                const connection = { plugUsername: username, socketProfileID: connectToProfileID };
                dispatch({ type: types.ADD_CONNECTION, connection });
                return connection;
            })
            .catch(error => {
                throw(error);
            });
    };
}

export function deleteConnection(username, connectToProfileID) {
    return (dispatch, getState) => {
        return artistService.deleteConnection(username, connectToProfileID)
            .then(data => {
                const connection = { plugUsername: username, socketProfileID: connectToProfileID };;
                dispatch({ type: types.DELETE_CONNECTION, connection });
                return connection;
            })
            .catch(error => {
                throw(error);
            });
    };
}